import {createNavigationContainerRef} from '@react-navigation/native';

/** Root ref for navigation when a screen's `navigation` prop is unreliable (e.g. password-reset flow). */
export const navigationRef = createNavigationContainerRef();
